(function() {
  function initHoverEffects() {
    const isMobile = window.innerWidth <= 425.98;

    document.querySelectorAll('.columbia-img-prod-text-image-item').forEach(function(imageItem) {
      const imageWrapper = imageItem.querySelector('.columbia-img-prod-text-image-wrapper');
      const hoverOverlay = imageWrapper ? imageWrapper.querySelector('.columbia-img-prod-text-image-hover-overlay') : null;
      const overlayText = imageWrapper ? imageWrapper.querySelector('.columbia-img-prod-text-image-overlay-text') : null;
      const button = imageWrapper ? imageWrapper.querySelector('.columbia-img-prod-text-image-overlay-button') : null;

      if (!hoverOverlay) return;

      // Agregar clase solo si existe hoverOverlay (para CSS desktop)
      if (!isMobile) {
        imageItem.classList.add('columbia-img-prod-text-image-item-has-hover');
      }

      function showHover() {
        hoverOverlay.style.opacity = '1';
        hoverOverlay.style.visibility = 'visible';
        if (overlayText) {
          overlayText.style.opacity = '0';
          overlayText.style.visibility = 'hidden';
        }
      }

      function hideHover() {
        hoverOverlay.style.opacity = '0';
        hoverOverlay.style.visibility = 'hidden';
        if (overlayText) {
          overlayText.style.opacity = '1';
          overlayText.style.visibility = 'visible';
        }
      }

      // Desktop: hover en toda la imagen
      if (!isMobile) {
        imageItem.addEventListener('mouseenter', showHover);
        imageItem.addEventListener('mouseleave', hideHover);
      }
      // Mobile: click en el botón
      else {
        if (button) {
          let isOpen = false;
          button.addEventListener('click', function(e) {
            e.stopPropagation();
            if (isOpen) {
              hideHover();
              isOpen = false;
            } else {
              showHover();
              isOpen = true;
            }
          });

          // Cerrar al hacer click fuera
          document.addEventListener('click', function(e) {
            if (isOpen && !imageWrapper.contains(e.target)) {
              hideHover();
              isOpen = false;
            }
          });
        }
      }
    });
  }

  // Inicializar al cargar
  initHoverEffects();

  // Reinicializar al cambiar el tamaño de ventana
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initHoverEffects();
    }, 250);
  });
})();
